export default __webpack_public_path__ + "static/media/606.3329a905.png";